/**
 * POST /api/admin/communications/preview — server-side preview render.
 *
 * Replaces SAMPLE_DATA-driven client-side render (TASK-074 Phase 2).
 * Hook: mutations/useCommunicationPreviewMutation.
 */
import { z } from 'zod';

export const PreviewWarningSchema = z.looseObject({
  code: z.string(),
  message: z.string(),
  variable: z.string().optional(),
  context: z.string().optional(),
});

export type PreviewWarning = z.infer<typeof PreviewWarningSchema>;

export const PreviewResponseSchema = z.looseObject({
  subject: z.string(),
  bodyHtml: z.string(),
  bodyText: z.string().optional(),
  warnings: z.array(PreviewWarningSchema).optional(),
  recipientCount: z.number().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type PreviewResponse = z.infer<typeof PreviewResponseSchema>;
